module.exports = __webpack_public_path__ + "img/conf-business.29067060.png";